// extracted by mini-css-extract-plugin
export default {"gridWrapper":"StoreTypeCreatorModal_gridWrapper__nnpob"};